module.exports = __webpack_public_path__ + "img/r-65.c6db0512.jpg";